export default __webpack_public_path__ + "static/media/Form_BackGround.b69a2ca1.webp";